/* src/components/search-bar/search-bar.component.scss */
.search-bar {
  position: relative;
  width: 100%;
  max-width: 400px;
  display: flex;
  align-items: center;
  align-content: center;
  border-radius: 20px;
  background-color: white;
  border: 1px solid #979797;
  padding: 4px 12px;
}
.search-bar .search-icon {
  color: #979797;
}
.search-bar input {
  flex: 1;
  font-size: 14px;
  background-color: transparent;
  outline: none;
  border: none;
  transition: border 0.2s;
  margin-left: 5px;
}
.search-bar input:focus {
  border-color: #666;
}
.search-bar .clear-btn {
  position: absolute;
  right: 8px;
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: #999;
  transition: color 0.2s;
}
.search-bar .clear-btn:hover {
  color: #333;
}
/*# sourceMappingURL=browser/search-bar.component.css.map */
